export const PRICING_REPORT_SCREEN_CHART_PLOT_HEIGHT_PX = 320;
export const PRICING_REPORT_PRINT_CHART_PLOT_HEIGHT_PX = 800;
export const PRICING_REPORT_FACET_MINI_CHART_HEIGHT_PX = 140;
export const PRICING_REPORT_PRINT_FACET_MINI_CHART_HEIGHT_PX = 260;

export const PRICING_REPORT_CHART_PLOT_SELECTOR = "[data-pricing-chart-plot]";
export const PRICING_REPORT_FACET_PLOT_SELECTOR = "[data-pricing-facet-plot]";
